/**
 * Maps a row from POST /v1/audit/list `body[]` to a stable UI shape.
 *
 * @param {Record<string, unknown>} row
 * @param {number} index
 */
export const mapAuditListRowToUi = (row, index) => {
  const createdAt = row.createdAt ?? row.created_at ?? '';
  return {
    id: `${String(createdAt)}-${index}`,
    userFullName: row.userFullName ?? row.user_full_name ?? '—',
    action: row.action != null && row.action !== '' ? String(row.action) : '—',
    section: String(row.section ?? '').trim(),
    item: row.item != null && row.item !== '' ? String(row.item) : '—',
    description: row.description != null ? String(row.description) : '',
    outcome: String(row.outcome ?? '').trim(),
    createdAt: String(createdAt),
  };
};
